module.exports = __webpack_public_path__ + "static/wave-1920x1080-37c296fa9d8d8528b8859dd2e8136d11.jpg";